import { useRef, useEffect } from "react";

export function Confetti({ trigger }) {
  const canvasRef = useRef(null);
  const animRef = useRef(null);
  const colors = ["#f59e0b","#ef4444","#0d9488","#8b5cf6","#3b82f6","#ec4899","#10b981","#f97316","#fbbf24","#a855f7"];
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const W = window.innerWidth, H = window.innerHeight;
    canvas.width = W; canvas.height = H;
    const ctx = canvas.getContext("2d");
    const particles = Array.from({length:120}, () => ({
      x: W*0.2 + Math.random()*W*0.6,
      y: H*0.4 + Math.random()*H*0.1,
      vx: (Math.random()-0.5)*8,
      vy: -6 - Math.random()*8,
      w: 7+Math.random()*9, h: 5+Math.random()*7,
      color: colors[Math.floor(Math.random()*colors.length)],
      angle: Math.random()*360, spin: (Math.random()-0.5)*8,
      gravity: 0.25+Math.random()*0.15, opacity: 1,
    }));
    const draw = () => {
      ctx.clearRect(0,0,W,H);
      let alive = false;
      particles.forEach(p => {
        p.vy += p.gravity; p.x += p.vx; p.y += p.vy;
        p.angle += p.spin; p.opacity = Math.max(0, p.opacity-0.008);
        if(p.y < H+30 && p.opacity > 0) {
          alive = true;
          ctx.save(); ctx.globalAlpha = p.opacity;
          ctx.translate(p.x, p.y); ctx.rotate(p.angle*Math.PI/180);
          ctx.fillStyle = p.color; ctx.fillRect(-p.w/2,-p.h/2,p.w,p.h);
          ctx.restore();
        }
      });
      if(alive) animRef.current = requestAnimationFrame(draw);
    };
    cancelAnimationFrame(animRef.current);
    animRef.current = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(animRef.current);
  }, [trigger]);
  return <canvas ref={canvasRef} style={{position:"fixed",top:0,left:0,width:"100vw",height:"100vh",pointerEvents:"none",zIndex:9999}}/>;
}

